export class Locations
{
	constructor(rootId, params = {})
	{
		this.iblockId = params.iblockId || '0';
		this.root = document.getElementById(rootId);
		if (this.root) {
			this.successButton = this.root.querySelector('.js_close_city_choice');
			this.confirmPopup = this.root.querySelector('.js-confirm-popup');
			this.openChooseLinks = this.root.querySelectorAll('.js-open-choose');
			if (this.successButton) {
				this.successButton.addEventListener('click', this.successButtonClickHandler.bind(this));
			}
			if (this.openChooseLinks.length) {
				[].forEach.call(this.openChooseLinks, link => {
					link.addEventListener('click', this.openChooseModalHandler.bind(this));
				});
			}
		}
	}

	successButtonClickHandler(evt = new Event('click')) {
		evt.preventDefault();

		BX.ajax.runComponentAction('itrack:locations', 'save', {
			mode: 'class',
			data: {
				id: this.successButton.dataset.id,
				iblockId: this.iblockId
			}
		}).then(() => {
			this.confirmPopup.remove();
		});
	}

	openChooseModalHandler(evt = new Event('click')) {
		evt.preventDefault();
		BX.ajax.runComponentAction('itrack:locations', 'getChooseModal', {
			mode: 'class',
			data: {
				iblockId: this.iblockId
			}
		}).then(resp => {
			this.cityList = resp.data.forSearch;
			$.fancybox.open(resp.data.html, {
				touch: false
			});
			this.initModal();
		});
	}

	initModal() {
		this.modal = document.getElementById('city_popup');
		this.modalLinks = this.modal.querySelectorAll('.js-set-city');
		this.searchInput = this.modal.querySelector('.js-city-search-input');
		if (this.modalLinks.length) {
			[].forEach.call(this.modalLinks, link => {
				link.addEventListener('click', this.setCityClickHandler.bind(this));
			});
		}
		if (this.searchInput) {
			$(this.searchInput).autocomplete({
				source: '/ajax/locations.php',
				appendTo: '.js-search-city-suggestion',
				minLength: 2,
				select: (evt, ui) => {
					console.log(ui.item);
					BX.ajax.runComponentAction('itrack:locations', 'save', {
						mode: 'class',
						data: {
							id: ui.item.ID,
							iblockId: this.iblockId
						}
					}).then(resp => {
						window.location.reload();
					});
				}
			});
		}
	}

	setCityClickHandler(evt = new Event('click')) {
		evt.preventDefault();
		const link = evt.currentTarget;
		BX.ajax.runComponentAction('itrack:locations', 'save', {
			mode: 'class',
			data: {
				name: link.dataset.city,
				id: link.dataset.id,
				iblockId: this.iblockId
			}
		}).then(resp => {
			window.location.reload();
		});
	}
}